export const ALERT_TYPE = {
  Success: 'Success',
  Error: 'Error',
  Info: 'Info',
} as const;

export type AlertType = (typeof ALERT_TYPE)[keyof typeof ALERT_TYPE];

export interface Alert {
  message: string;
  type?: AlertType;
  duration?: number;
}

export type AlertLogLevel =
  | 'trace'
  | 'debug'
  | 'info'
  | 'log'
  | 'warn'
  | 'error'
  | 'fatal'
  | 'off';

export interface AlertNotifyOptions {
  log?: AlertLogLevel;
}
